// extracted by mini-css-extract-plugin
export default {"btnPrev":"aO2rw","btnNext":"HUPTy","emblaWrapper":"RsOQl","embla":"t2kYq","emblaContainer":"D_vk5","tile":"OMZPE"};